module.exports = __webpack_public_path__ + "static/media/pov_whole_GreatDodecahedron.5a187fa0.png";